import { Icon, Typography } from 'src/modules/core/components'
import { BookingLogo } from '../booking-logo'
import classes from './booking-disabled.module.scss'

import type { BookingDisabledProps } from './booking-disabled.interface'

export function BookingDisabled({ providerName, logoUrl }: BookingDisabledProps) {
  return (
    <div className={classes.root}>
      <BookingLogo
        logoUrl={logoUrl}
        alt={providerName}
        className={classes.headerLogo}
        fallback={
          <div className={classes.headerIcon}>
            <Icon name="calendarCanceled" />
          </div>
        }
      />
      <Typography variant="h1" className={classes.title}>
        Bookings Disabled
      </Typography>
      <Typography variant="body" className={classes.message}>
        We&apos;re sorry, but {providerName || 'this provider'} has disabled bookings.
      </Typography>
    </div>
  )
}
